import { useEffect } from 'react';

/**
 * @param {Function} callback
 * @description Adds an keydown event listener and removes it on clean-up.
 * The listener executes the callback when the specified event keycode is detected.
 */
const useDocumentKeyDown = (keycode, callback) => {
    const handleKeyDown = (e) => {
        if (e.keyCode === keycode) {
            callback();
        }
    };

    useEffect(() => {
        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    });
};

export default useDocumentKeyDown;
